import React from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import ReactPaginate from "react-paginate";

const Pagination = ({ setPage, pageCount }) => {
  const handlePageClick = (data) => {
    setPage(data.selected + 1);
  };
  return (
    <div className="">
      <ReactPaginate
        previousLabel={
          <div className="flex items-center">
            <FiArrowLeft className="text-xl" /> Previous
          </div>
        }
        nextLabel={
          <div className="flex items-center">
            Next <FiArrowRight className="text-xl" />
          </div>
        }
        breakLabel={"..."}
        pageCount={pageCount - 1}
        marginPagesDisplayed={2}
        pageRangeDisplayed={2}
        onPageChange={handlePageClick}
        containerClassName={"flex items-center justify-center gap-2 "}
        pageClassName={" text-accent font-semibold "}
        pageLinkClassName={" text-accent font-semibold px-3 py-1"}
        previousClassName={
          "absolute left-0 lg:bottom-16 md:bottom-16 bottom-0    border border-gray-200 shadow px-2 py-1 rounded-lg"
        }
        previousLinkClassName={""}
        nextClassName={
          "absolute right-0 lg:bottom-16 md:bottom-16 bottom-0   border border-gray-200 shadow px-2 py-1 rounded-lg"
        }
        nextLinkClassName={""}
        breakClassName={" text-accent font-semibold"}
        breakLinkClassName={""}
        activeClassName={"bg-[#E6FEF2] text-primary px-3 py-1 rounded shadow"}
      />
    </div>
  );
};

export default Pagination;
